import React from "react";
import Cx from "classnames";
import Draggable from "draggable";

import styles from "./styles.scss";

export default class ArchivedDocActions extends React.Component {
  state = {
    open: false,
  };

  downloadOriginal = (e) => {
    e.preventDefault();
    const originalUrl = this.props.archivedItems
      .filter((item) => item.selected)
      .map((i) => i.original)[0];

    if (originalUrl.length) window.open(originalUrl, "_blank");
  };

  handleClickOutside = (event) => {
    const ref = this.props.archivedItemsRef;

    if (
      !(
        (ref && ref.contains(event.target)) ||
        (this._el && this._el.contains(event.target))
      )
    ) {
      // not sure why this needs to be delayed
      setTimeout(() => {
        this.selectNone();
      }, 200);
    }
  };

  restoreItems = () => {
    let { items, archivedItems, onDocAction } = this.props;
    const itemsToRestore = archivedItems.filter((x) => x.selected);
    const itemsNew = items.concat(itemsToRestore);
    const itemIdsToRestore = itemsToRestore.map((i) => i.id);
    const archivedItemsNew = archivedItems.filter(
      (i) => !itemIdsToRestore.includes(i.id)
    );

    onDocAction(itemsNew, archivedItemsNew);
  };

  selectAll = () => {
    let { items, onDocAction } = this.props;
    const archivedItems = this.props.archivedItems.map((i) => {
      let item = i;
      item.selected = true;
      return item;
    });

    onDocAction(items, archivedItems);
  };

  selectNone = () => {
    let { items, onDocAction, archivedItems } = this.props;
    archivedItems = archivedItems || [];
    const archivedItemsNew = archivedItems.map((i) => {
      let item = i;
      item.selected = false;
      return item;
    });

    onDocAction(items, archivedItemsNew);
  };

  componentDidUpdate(prevProps) {
    const hasSelectedItems = this.props.items.filter(
      (item) => item.selected
    ).length;
    if (hasSelectedItems && !this.state.open) this.setState({ open: true });

    if (this._el) {
      if (prevProps.isFullscreen !== this.props.isFullscreen) {
        this._el.style.left = "";
      }
      this._el.style.height = "";
      this._el.style.width = "";
      this._el.style.transform = "";
      this._draggable = new Draggable(this._el, { handle: this._handle });
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  render() {
    const selectedItems = this.props.archivedItems.filter(
      (item) => item.selected
    );
    if (!selectedItems.length) return <div />;

    return (
      <ul
        className={Cx(styles.actions)}
        ref={(c) => {
          this._el = c;
        }}
      >
        <li
          className={styles.handle}
          ref={(c) => {
            this._handle = c;
          }}
        >
          <span />
        </li>
        <li onMouseDown={this.restoreItems}>Restore 💫</li>
        <li onMouseDown={this.downloadOriginal}>Download Original</li>
        <li onMouseDown={this.selectAll}>Select All</li>
        <li onMouseDown={this.selectNone}>Close</li>
      </ul>
    );
  }
}
